import useRedirectAfterLogin from 'hooks/useRedirectAfterLogin';
import PropTypes from 'prop-types';
import { FC, ReactNode, useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useSelector } from 'store';
import useBaseLinks from 'store/Auth/Links/useBaseLinks';
import useAuth from 'store/Auth/useAuth';

interface AuthenticatedProps {
  children: ReactNode;
}

const Authenticated: FC<AuthenticatedProps> = (props) => {
  const { children } = props;
  const navigate = useNavigate();
  const { getLink } = useBaseLinks();
  const { map } = useSelector((state) => state.baseLinks);
  const { getUrl, clearUrl, setUrl } = useRedirectAfterLogin();
  const { isLoggedIn } = useAuth();
  const savedUrl = getUrl();

  //Added to authenticate logged in user
  useEffect(() => {
    if (map) {
      const userLink = getLink('me');
      if (!userLink) {
        localStorage.removeItem('userAuthToken');
        localStorage.removeItem('loggedInUserUUID');
        navigate('login');
      }
    }
  }, [map, getLink, navigate]);

  if (!isLoggedIn) {
    if (location.pathname !== savedUrl) {
      setUrl();
    }
    return <Navigate to={'/login'} />;
  }

  if (savedUrl && location.pathname !== savedUrl) {
    clearUrl();
    return <Navigate to={savedUrl} />;
  }

  return <>{children}</>;
};

Authenticated.propTypes = {
  children: PropTypes.node,
};

export default Authenticated;
